import { Input } from 'antd';

// Телефон хранится и показывается как +7 (900) 000-00-00. Пустая строка — поле не заполнено.
export function formatPhone(value) {
    let digits = String(value ?? '').replace(/\D/g, '');
    if (!digits) return '';
    if (digits[0] === '8') digits = `7${digits.slice(1)}`;
    if (digits[0] === '7') digits = digits.slice(1);
    digits = digits.slice(0, 10);
    const area = digits.slice(0, 3);
    const mid = digits.slice(3, 6);
    const pair = digits.slice(6, 8);
    const tail = digits.slice(8, 10);
    let text = '+7';
    if (area) text += ` (${area}`;
    if (area.length === 3) text += ')';
    if (mid) text += ` ${mid}`;
    if (pair) text += `-${pair}`;
    if (tail) text += `-${tail}`;
    return text;
}

export function isCompletePhone(value) {
    return /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(formatPhone(value));
}

export function normalizeEmail(value) {
    return String(value ?? '').replace(/\s/g, '');
}

export function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizeEmail(value));
}

export const PhoneInput = ({ value, onChange, ...rest }) => {
    const shown = value ? formatPhone(value) : '';
    const emit = (raw) => {
        const next = formatPhone(raw);
        onChange?.(next);
    };
    return (
        <Input
            {...rest}
            value={shown}
            inputMode="tel"
            autoComplete="off"
            onChange={(e) => emit(e.target.value)}
            onKeyDown={(e) => {
                if (e.key !== 'Backspace') return;
                const pos = e.currentTarget.selectionStart ?? 0;
                if (pos !== e.currentTarget.selectionEnd || pos === 0) return;
                if (/\d/.test(shown[pos - 1] ?? '')) return;
                e.preventDefault();
                const digitsBefore = shown.slice(0, pos).replace(/\D/g, '').length;
                const all = shown.replace(/\D/g, '');
                if (digitsBefore === 0) return;
                emit(all.slice(0, digitsBefore - 1) + all.slice(digitsBefore));
            }}
        />
    );
};

export const EmailInput = ({ value, onChange, ...rest }) => (
    <Input
        {...rest}
        value={value ?? ''}
        inputMode="email"
        autoComplete="off"
        onChange={(e) => onChange?.(normalizeEmail(e.target.value))}
    />
);
